import { useState } from "react";
import { IoFileTrayOutline, IoSyncOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import Toaster from "./../../../components/common/Toaster";
import complianceService from "./../../../services/complianceService";

const CorEmptyState = ({ id, onRefresh }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerate = async () => {
    try {
      setIsLoading(true);

      await complianceService.generateCORDeadlinesAsync(id);

      Toaster.Success("Deadlines Generated Successfully");
      setIsLoading(false);
      onRefresh();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setIsLoading(false);
    }
  };

  return (
    <div className="min-w-max border-t">
      <div className="flex items-center justify-center m-10 h-52">
        <div className="text-center">
          <IoFileTrayOutline className="text-6xl mx-auto text-gray-400" />
          <p className="text-gray-500 text-lg font-semibold text-center">
            No deadlines yet
          </p>
          <div className="mx-auto mt-1">
            <span className="text-sm text-gray-500">
              Click the button below to generate deadlines for this COR.
            </span>
          </div>
          <button
            className="button button-primary w-2/4 mt-10"
            onClick={() => handleGenerate()}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSyncOutline className="mr-3" />}
            Generate Deadlines
          </button>
        </div>
      </div>
    </div>
  );
};

export default CorEmptyState;
